import View from './view';

export { componentName } from 'src/components/sorter-rule-preview/const';
export default View;
